import { CancelTokenSource } from 'axios';
import {
  TMentoringClassCreate,
  TAvailableSchedule,
  TWeekSchedule,
  TMentoringClass,
  TUpdateMentoringClassSchedule,
  TMentoringFeedback,
  TMentoringReview,
  TMentoringReviewsForLanding,
  TMentoringPassCasesForLanding,
  TMentoringCancel,
  TMentoringReject,
  TCreatePaymentLog,
  TVerifyPaymentLog,
  TUpdateMentoringClass,
  TVerifymobilePaymentLog,
  TMentoringReview2,
} from 'modules/mentoring';
import { TListRequestParams, TListResponse, TSelectList } from 'modules/types';
import { TScheduleStatus } from 'modules/user';
import apiClient, { makeQueryString, WrappingApiClient } from './apiClient';

/**
 * 수업 신청
 */
export const mentoringClassCreate = (params: Array<TMentoringClassCreate>, cancel?: CancelTokenSource) => {
  return apiClient.post('/mentoring/mentoring_class/create', params, {
    cancelToken: cancel?.token,
  });
};

export const selectMentoringClassTopic = (cancel?: CancelTokenSource) => {
  return apiClient.get<TSelectList>('/mentoring/mentoring_class_topic/select', {
    cancelToken: cancel?.token,
  });
};

export const getMentoringClass = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.get<TMentoringClass>(`/mentoring/mentoring_class/${id}`, {
    cancelToken: cancel?.token,
  });
};

//스케줄 수정
export const updateMentoringClassSchedule = (
  id: number,
  params: TUpdateMentoringClassSchedule,
  cancel?: CancelTokenSource,
) => {
  return apiClient.put(`/mentoring/mentoring_class/${id}`, params, {
    cancelToken: cancel?.token,
  });
};

//희망토픽, 파일, 추가 요청사항 수정
export const updateMentoringClass = (
  id: number,
  params: TUpdateMentoringClass,
  cancel?: CancelTokenSource,
) => {
  return apiClient.put(`/mentoring/mentoring_class/${id}?${makeQueryString({ file: 'file' })}`, params, {
    cancelToken: cancel?.token,
  });
};

/**
 * Available schedule
 */
export const getAvailableSchedule = (
  mentorId: number,
  params?: TWeekSchedule,
  cancel?: CancelTokenSource,
) => {
  return apiClient.get<Array<TAvailableSchedule>>(`/mentoring/available_schedule/${mentorId}`, {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const updateAvailableSchedule = (
  params: Array<TScheduleStatus>,
  isAutoUpdate?: { auto_time_slot: string },
  cancel?: CancelTokenSource,
) => {
  return apiClient.post(`/mentoring/available_schedule/update?${makeQueryString(isAutoUpdate)}`, params, {
    cancelToken: cancel?.token,
  });
};

/**
 * Mentoring Class list
 */
export const getUpcomingMentoringClasses = ({ params }: TListRequestParams, cancel?: CancelTokenSource) => {
  return apiClient.get<TListResponse<TMentoringClass>>('/mentoring/upcoming_mentoring_classes', {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const getPastMentoringClasses = (
  withId: number,
  { params }: TListRequestParams,
  cancel?: CancelTokenSource,
) => {
  return apiClient.get<TListResponse<TMentoringClass>>(
    `/mentoring/past_mentoring_classes?with_id=${withId}`,
    {
      params: params,
      cancelToken: cancel?.token,
    },
  );
};

/*
 * Feedback
 */
export const mentoringFeedbackCreate = (params: TMentoringFeedback, cancel?: CancelTokenSource) => {
  return apiClient.post(`/mentoring/mentoring_class_feedback/create`, params, {
    cancelToken: cancel?.token,
  });
};

export const getMentoringFeedback = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.get<TMentoringFeedback>(`/mentoring/mentoring_class_feedback/${id}`, {
    cancelToken: cancel?.token,
  });
};

export const updateMentoringFeedback = (
  id: number,
  params: TMentoringFeedback,
  cancel?: CancelTokenSource,
) => {
  return apiClient.put(`/mentoring/mentoring_class_feedback/${id}`, params, {
    cancelToken: cancel?.token,
  });
};

/**
 * Payment
 */

export const createPaymentLog = (params: TCreatePaymentLog, cancel?: CancelTokenSource) => {
  return apiClient.post('/credit/payment/create', params, {
    cancelToken: cancel?.token,
  });
};
//결제 요청 성공 시(if (rsp.success)) 실행(결제 완료되었을 때)
//서버의 결제 정보를 받는 endpoint
//결제번호(imp_uid)와 주문번호(merchant_uid)를 서버에 전달
export const verifyPayment = (param: TVerifyPaymentLog, cancel?: CancelTokenSource) => {
  return apiClient.post('/credit/payment/verify', param, {
    cancelToken: cancel?.token,
  });
};
export const verifyMobilePayment = (params: TVerifymobilePaymentLog, cancel?: CancelTokenSource) => {
  return apiClient.get(`/credit/payment/verify?${makeQueryString(params)}`, {
    cancelToken: cancel?.token,
  });
};

/*
 * Review
 */
export const mentoringReviewCreate = (params: TMentoringReview, cancel?: CancelTokenSource) => {
  return apiClient.post('/mentoring/mentoring_class_review/create', params, {
    cancelToken: cancel?.token,
  });
};

export const mentoringReviewCreate2 = (params: TMentoringReview2, cancel?: CancelTokenSource) => {
  return apiClient.post('/mentoring/mentoring_class_review/create', params, {
    cancelToken: cancel?.token,
  });
};

export const getMentoringReviews = (
  id: number,
  { params }: TListRequestParams,
  cancel?: CancelTokenSource,
) => {
  return apiClient.get<TListResponse<TMentoringReview>>(`/mentoring/mentoring_reviews/${id}`, {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const getMentoringReview = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.get<TMentoringReview>(`/mentoring/mentoring_review/${id}`, {
    cancelToken: cancel?.token,
  });
};

export const getMentoringReview2 = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.get<TMentoringReview2>(`/mentoring/mentoring_review/${id}`, {
    cancelToken: cancel?.token,
  });
};

export const getMentoringReviewsForLanding = ({ params }: any, cancel?: CancelTokenSource) => {
  return apiClient.get<TMentoringReviewsForLanding>(`/mentoring/mentoring_reviews/for_landing`, {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const getMentoringPassCasesForLanding = ({ params }: any, cancel?: CancelTokenSource) => {
  return apiClient.get<TMentoringPassCasesForLanding>(`/mentoring/pass_cases/for_landing`, {
    params: params,
    cancelToken: cancel?.token,
  });
};

/**
 * 수업 상태 변경
 */
export const acceptMentoringClass = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.post(`/mentoring/mentoring_class/${id}/accept`, {
    cancelToken: cancel?.token,
  });
};

// export const rejectMentoringClass = (id: number, cancel?: CancelTokenSource) => {
//   return apiClient.post(`/mentoring/mentoring_class/${id}/reject`, {
//     cancelToken: cancel?.token,
//   });
// };

export const rejectMentoringClass = (id: number, params?: TMentoringReject, cancel?: CancelTokenSource) => {
  return apiClient.post(`/mentoring/mentoring_class/${id}/reject`, params, {
    cancelToken: cancel?.token,
  });
};

export const cancelMentoringClass = (id: number, params: TMentoringCancel, cancel?: CancelTokenSource) => {
  return apiClient.post(`/mentoring/mentoring_class/${id}/cancel`, params, {
    cancelToken: cancel?.token,
  });
};

export const getDashboardStatistics = (params: { score_type: string }) => {
  return WrappingApiClient(apiClient.get('/dashboard/myscore_graph?' + makeQueryString(params)));
};

export const getMyAverageScore = () => {
  return WrappingApiClient(apiClient.get('/dashboard/my_average_score_graph'));
};
export const getPassedAverageScore = () => {
  return WrappingApiClient(apiClient.get('/dashboard/passed_score_graph'));
};

export const getDashboardCompanyStatistics = () => {
  return WrappingApiClient(apiClient.get('/dashboard/company_graph'));
};
export const getDashboardMentorStatistics = (params: { current: number; pageSize: number }) => {
  return WrappingApiClient(apiClient.get(`/dashboard/mentor_feedback?${makeQueryString(params)}`));
};
export const patchInterviewDate = (interview_date: string) => {
  return WrappingApiClient(apiClient.patch('/change_interview_date', { interview_date }));
};

//Q&A 게시판 보이는 유저 리스트 get
export const getQNAAccessUser = () => {
  return apiClient.get('library/qna/user');
};
